"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnexionInstructionsWithVideo = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = require("rn-css");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const connexion_instructions_1 = require("./connexion_instructions");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_all_1 = require("@unboared/base-ui.all");
const ConnexionInstructionsWithVideo = ({ style, roomID, url, connectedPlayers, masterID, urlVideo, test }) => {
    const video = react_1.default.useRef(null);
    // Get utils for responsiveness
    const theme = (0, rn_css_1.useTheme)();
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const currentTheme = theme || base_ui_theme_themes_1.unboaredTheme.default;
    const styleContainer = [
        {
            width: '100%',
            height: '100%',
            flexDirection: 'row'
        },
        style
    ];
    return (react_1.default.createElement(react_native_1.View, { style: styleContainer },
        react_1.default.createElement(react_native_1.View, { style: { flex: 1, backgroundColor: currentTheme.backgroundColor } },
            react_1.default.createElement(connexion_instructions_1.ConnexionInstructions, { roomID: roomID, url: url, connectedPlayers: connectedPlayers, masterID: masterID, test: test })),
        react_1.default.createElement(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
            react_1.default.createElement(react_native_1.View, { style: {
                    margin: normalize(base_ui_theme_spacing_1.space.huge)
                } },
                react_1.default.createElement(base_ui_all_1.Video, { style: {
                        width: '100%',
                        height: '100%',
                        borderRadius: normalize(base_ui_theme_spacing_1.space.large),
                    }, source: urlVideo || "https://unboared.com/wp-content/uploads/2022/08/Unboared_Ingame_Video.mp4" })))));
};
exports.ConnexionInstructionsWithVideo = ConnexionInstructionsWithVideo;
//# sourceMappingURL=connexion_instructions_with_video.js.map